<div class="toggle-container" [class.disabled]="disabled">
  <button
    type="button"
    class="toggle-option"
    [class.selected]="value"
    (click)="toggleValue(true)"
    [disabled]="disabled"
  >
    {{ value ? enabledLabel : enableLabel }}
  </button>
  <button
    type="button"
    class="toggle-option"
    [class.selected]="!value"
    (click)="toggleValue(false)"
    [disabled]="disabled"
  >
    {{ value ? disableLabel : disabledLabel }}
  </button>
</div>
